import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import FlowLayoutItemViewModelType from '@/ViewModels/Controls/FlowLayoutItemViewModel';

export default class FlowLayoutItem extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: FlowLayoutItemViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'flowlayoutitem',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            flowLayoutItem: {
                tuple: this.viewModel.tuple
            }
        });

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('FlowLayoutItem', FlowLayoutItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');